import classnames from 'classnames'
import React, { useCallback } from 'react'
import { ROUTE_ITINERARY_OPTIONS_DIALOG } from '../../routes'
import { navigateTo } from '../../store/history/history.actions'
import gear from '../genericComponents/assets/gear.svg?raw'
import T from '../i18n/T'
import { useAction } from '../utils/react-redux'
import s from './OptionButton.less'

const ItineraryOptionButton = ({ className }) => {
  const execNavigateTo = useAction(navigateTo)
  const onClick = useCallback(() => execNavigateTo({ route: ROUTE_ITINERARY_OPTIONS_DIALOG }), [])

  return (
    <div className={classnames(s.OptionButton, s.myOptionsButton, className)} onClick={onClick}>
      <div className={classnames('icon', s.icon)} dangerouslySetInnerHTML={{ __html: gear }}></div>
      <span>
        <T id="itinerary.options" />
      </span>
    </div>
  )
}

export default ItineraryOptionButton
